<template>
  <a-tooltip
    padding="anz-py-s"
    v-if="calledSuperLikeAction"
    @tooltip-close="$emit('tooltip-close')"
  >
    <template #title>
      <template v-if="postSuperLikeAlreadyPerformed">
        {{ $translate('post.actionResults.alreadyVotedStart') }}
        <strong class="anz-strong">{{
          $translate('post.actionResults.alreadyVotedStrong')
        }}</strong>
        {{ $translate('post.actionResults.alreadyVotedEnd') }}
      </template>
      <template v-else>
        <strong class="anz-strong">{{
          $translate('post.actionResults.votedStrong')
        }}</strong
        >{{ $translate('post.actionResults.votedEnd') }}
      </template>
    </template>
  </a-tooltip>
  <a-tooltip padding="anz-py-s" v-else @tooltip-close="$emit('tooltip-close')">
    <template #title>
      {{ $translate('post.tooltip.superLike.confirmation') }}
    </template>
    <template #action>
      <a-button
        className="anz-btn anz-btn-primary anz-btn-s anz-fc-icon anz-mt-s anz-mt-0-sm anz-wf-mo anz-ml-auto"
        :title="$translate('post.tooltip.superLike.confirmationAction')"
        :loading="isPerformingSuperLike"
        :disabled="isPerformingSuperLike"
        @click="superLike"
        icon-width="0.7142em"
        icon-height="0.7142em"
        icon-class="anz-mr-xs"
        loader-class="anz-spinner-xxs"
      ></a-button>
    </template>
  </a-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import AButton from '@/components/Forms/AButton.vue'
import { Post } from '@/model/data-object/Post'
import { useRouter } from '@/routing/router'
import usePostSuperLike from '@/composables/post-super-like/postSuperLike'
import ATooltip from '@/components/Ui/ATooltip.vue'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_SUPER_LIKE,
  emits: ['tooltip-close'],
  components: { ATooltip, AButton },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    return {
      ...usePostSuperLike(props.post as Post),
      ...useRouter(),
    }
  },
})
</script>
